export const BRAND_DEFAULTS = {
  brandPrimary: "#1890FF",
  brandPrimaryHover: "#0078E5",
  brandPrimaryPressed: "#005DB2",
  brandSecondary: "#EBF5FF",
  brandSecondaryHover: "#E0F0FF",
  brandSecondaryPressed: "#D6EBFF",
};

export const COLOR_SCHEME = {
  LIGHT: {
    grey50: "#FFFFFF",
    grey100: "#FDFDFD",
    grey150: "#FAFAFA",
    grey200: "#F5F5F5",
    grey300: "#E9EAEB",
    grey400: "#D6D7D9",
    grey500: "#A6A8AC",
    grey600: "#74777D",
    grey700: "#57595E",
    grey800: "#45484D",
    grey850: "#292C33",
    grey900: "#1B1E24",
    grey950: "#0C0D10",
    grey1000: "#000000",
    error: "#FF4D4F",
    errorSecondary: "#FFEDED",
    alert: "#FEC242",
    alertSecondary: "#FFFBE7",
    success: "#1AC45B",
    successSecondary: "#E8F9EF",
    heart: "#FF8182",
    heartSecondary: "#FFDBDB",
    flagged: "#FC8C3A",
  },
  DARK: {
    grey50: "#000000",
    grey100: "#0C0D10",
    grey150: "#1B1E24",
    grey200: "#2B2D31",
    grey300: "#45484D",
    grey400: "#57595E",
    grey500: "#74777D",
    grey600: "#A6A8AC",
    grey700: "#D6D7D9",
    grey800: "#E9EAEB",
    grey850: "#F5F5F5",
    grey900: "#FAFAFA",
    grey950: "#FDFDFD",
    grey1000: "#FFFFFF",
    error: "#FF8182",
    errorSecondary: "#400000",
    alert: "#FED682",
    alertSecondary: "#413700",
    success: "#51DB86",
    successSecondary: "#196237",
    heart: "#FF5F60",
    heartSecondary: "#6A0607",
    flagged: "#FFAA6B",
  },
};
